import store from "../store";
import router from "../router";
import ErrorService from "./ErrorService";
import BaseService from "./BaseService";
import Utils from "../helpers/utils";
import VidyoService from "./VidyoService";
import $ from "jquery";

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
export default class ConversationService {
  constructor() {
    this.chatEventHeader = "[ccspChatEvent]";

    // this.getEventTimeOut = null;
  }

  
  async getEvents(onChatStatusReceived, onChatDisconnect) {
    if (store.getters.isConnect !== true) {
      Utils.log.debug("Skipping events loop as not connected");
      return;
    }
    Utils.log.debug("Getting events loop starting...");
    var req = this.getEventsInner(onChatStatusReceived, onChatDisconnect);
    var mySession = sessionStorage.getItem("cc_sessionId");
    while (req === false && store.getters.isConnect && (!localStorage.getItem("cc_sessionId") || mySession == localStorage.getItem("cc_sessionId"))) {
      Utils.log.debug("store.getters.isConnect", store.getters.isConnect);
      let timeoutInstance;
      // Wait until next poll is due
      await new Promise((r) => {
        timeoutInstance = setTimeout(
          r,
          store.state.appData.DataGlobal.getEventsTimeoutMS
        );
      });
      clearTimeout(timeoutInstance);
      req = this.getEventsInner(onChatStatusReceived, onChatDisconnect);
    }
    Utils.log.debug("Getting events loop stopped");

    // Exceeded poll attempts or discconected during the loop
    if (req == true || store.getters.isConnect == false) {
      let message = "";
      if (req == true) {
        message = "Disconnected due to max polling interval reached";
        Utils.log.error("Disconnected due to max polling interval reached");
        //sometimes the server with long delay, if its exceeded the time and maxPolling and there isn't response
        //it can be that server disconnected or in long delay, so to be sure that call indeed ended, we dispach "leaveChat"
        //the "leaveChat" will trigger only if "getEvents" doesn't response error.

        if (!store.state.getEventsGotError) {
          store.dispatch("leaveChat", { isAsync: true });
        }
      }

      VidyoService.disconnectVidyoCall();
      // If externally controlled and going to a survey don't push to chat as it will hide the panel
      if ((store.getters.widgetData.config.externalController != true) || store.getters.widgetData.config.isPostSurvey != true || store.getters.isAgentRespond != true) {
        Utils.log.debug("No external controller/survey, routing to chat");
        store.commit("setCurrentView", "chat");
      }
      store.commit("setConnId", -1);
      store.commit("setConnectedToCallCenter", false);
      store.commit("setVideoMessage", null);

      if (req == true) {
        ErrorService.displayAlert(
          store.getters.widgetData.errorAlerts.maxPolls || message
        );
        Utils.postMessageObject("error", message);
      }
    } else if (mySession != localStorage.getItem("cc_sessionId")) {
      try {
        sessionStorage.removeItem("cc_resumed");
        $("custom-chat").hide(); // hide me
        $("#chat-view").hide(); // hide me
      } catch (err) {
        Utils.log.debug("getEvents another session has taken control but could not unload this", err);
      }
    }
  }

  getEventsInner(onChatStatusReceived, onChatDisconnect) {
    //if not connected - so its mean error, because it suppose to come here only when it's connected.
    if (!store.getters.isConnect) {
      return null;
    }
    var curSession = localStorage.getItem("cc_sessionId");
    var mySession = sessionStorage.getItem("cc_sessionId");
    if (curSession && curSession != mySession) {
      if (store.getters.isSCOverride) {
        // Set the session ID back to ours as we don;t cross tabs in SC mode
        localStorage.setItem("cc_sessionId", mySession);
      }
      else {
        Utils.log.info("Stopping polling as another session has taken control " + curSession + " vs " + mySession);  
        try {
          sessionStorage.removeItem("cc_resumed");
          $("custom-chat").hide(); // hide me
          $("#chat-view").hide(); // hide me
          if (store.getters.widgetData.conversationView.chatResumedMessage)
            toast.info(store.getters.widgetData.conversationView.chatResumedMessage, {"bodyClassName":"toastResumedAlert", "autoClose":false});
        } catch (err) {
          Utils.log.debug("getEventsInner another session has taken control but could not unload this", err);
        }
        return null;
      }
    }

    Utils.log.debug(
      `PollingCounter is: ${store.state.pollingCounter}, and MaxPolling is: ${store.getters.widgetData.config.maxPolling}`
    );

    var exceeded =
      store.state.pollingCounter >= store.getters.widgetData.config.maxPolling;
    Utils.log.debug("Exceeded poll attempts = " + exceeded);
    if (exceeded) return true;

    store.dispatch("getEvents").then((res) => {
      if (!res || !res.Events) {
        // Utils.log.info("No Events");
        return;
      }
      var json = JSON.stringify(res);
      if (store.state.lastResponse == json) {
        Utils.log.debug("Ignoring duplicated response:" + json);
        return;
      }
      store.state.lastResponse = json;

      //parsing the new incoming events
      res.Events.forEach((item) => {
        //the "lastEventId" needed for the next "getEvents" server call, it's a part of URL.
        store.commit("setLastEventId", item.Event_ID);
        switch (item.Command) {
          case "read": {
            store.commit("setParticipantName", item.Participant_Name);
            store.commit("setRedDot", true);
            store.commit("setNewMessageCome", true);
            if (
              store.getters.widgetData.videoConfig.messageIncomingSoundUrl &&
              store.state.currentView.viewName === "video"
            ) {
              let audio = new Audio(
                store.getters.widgetData.videoConfig.messageIncomingSoundUrl
              );
              audio.play();
            }
            let chatResult = {
              id: item.Event_ID,
              author: store.getters.participantName,
              author_type: "CCU",
              gravatar: "CCU",
              text: item.Message_Text.replace(/</g, "&lt;").replace(
                />/g,
                "&gt;"
              ),
              URL_Pushed: item.URL_Pushed, //if got a link
              Additional_Information: item.Additional_Information,
            };
            this.onChatMessageReceived(chatResult);
            break;
          }
          case "status": {
            Utils.postMessageObject("ccspEvent", item);
            let statusDesc = "";
            let status = store.getters.appData.StatusRes[item.Status_Code];
            if (status) {
              //get th status description from Json file.
              statusDesc = status.description;
            }
            let chatResult = {
              id: item.Event_ID,
              Status_Code: item.Status_Code,
              Estimated_Time: item.Estimated_Time,
              Status_Desc: statusDesc
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;"),
              Additional_Information: item.Additional_Information,
              Call_Id: item.CallID,
            };
            onChatStatusReceived(chatResult);
            break;
          }
          case "ParticipantDisconnected": {
            Utils.postMessageObject("ccspEvent", item);
            onChatDisconnect(item.Participant_Name);
            break;
          }
          case "typingStatus": {
            this.onAgentTyping(item.Message_Text);
            break;
          }
          case "Error": {
            Utils.postMessageObject("ccspEvent", item);
            ErrorService.onChatError(item.Error_Code, null);
            break;
          }
        }
      });
    });
    return false;
  }

  //add chat line at the store
  onChatMessageReceived(result) {
    store.commit("setAgentTyping", false);
    let isVideoMessage;
    isVideoMessage = VidyoService.isVidyoInviteMessage(result);
    if (isVideoMessage) {
      store.commit("setNewMessageCome", false);
      Utils.log.debug("got videoMessage", result);
      if (
        store.getters.widgetData.config.videoVendor &&
        store.getters.widgetData.config.videoVendor !== ""
      ) {
        store.commit("setVideoLoader", true);
        store.commit("setVideoMessage", result);

        Utils.log.debug("VideoMessage: ", result);
        /*always need to setCurrentView, even to kiosk mode, since the Vidyo.vue  
        have watcher on CurrentView*/
        store.commit("setCurrentView", "video");

        if (store.getters.widgetData.config.isKioskNoChatUntilVideo && store.getters.widgetData.config.isKioskMode) {
          let vid = document.getElementById("preVideoMp4");
          if (vid) {
            vid.pause();
            vid.currentTime = 0;
            vid.volume = 0;
            vid.remove();
          }
          store.commit("setConnectedToCallCenter", true);
          router.push("ConversationView");
        }
      } else {
        ErrorService.displayAlert(
          store.getters.widgetData.errorAlerts.notConfiguredVideo ||
            "Video chat vendor not configured"
        );
      }
    } else if (
      result.text.indexOf("vidyo_end_video_call") > -1 ||
      result.text.indexOf("can_not_start_video") > -1
    ) {
      Utils.log.debug("got " + result.text + " message");
      store.commit("setAgentAutoMessage", result.text);
    } else if (result.text.indexOf("vidyo_recording_") > -1) {
      Utils.log.debug("got vidyo_recording message", result);
    } else if (!this.isChatEvent(result)) {
      this.addChatLine(result);
    }
  }

  //Determine if the item is chat event (system/chat message) or not.
  isChatEvent(item) {
    return item && item.text && item.text.indexOf(this.chatEventHeader) === 0;
  }

  addChatLine(line) {
    store.commit("addChatLine", line);
  }

  onAgentTyping(typingStatus) {
    store.commit("setAgentTyping", typingStatus);
  }

  addSystemMessage(message) {
    let params = {
      isSystemMessage: true,
      text: message.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
    };
    this.addChatLine(Object.assign({}, params));
    if (store.getters.widgetData.config.externalController == true)
      window.parent.postMessage({CC:{"systemMessage":message}}, "*");

  }
}
